module.exports = __webpack_public_path__ + "assets/img/standard.c50993b4.svg";